// extracted by mini-css-extract-plugin
export var copyableField = "_pz-4";
export var customerBadge = "_pz-0";
export var customerInfoTitle = "_pz-2";
export var details = "_pz-1";
export var dropdownContainer = "_pz-5";
export var dropdownImage = "_pz-6";
export var editAssigneeForm = "_pz-a";
export var editButton = "_pz-3";
export var email = "_pz-7";
export var hidden = "_pz-d";
export var input = "_pz-8";
export var saveButton = "_pz-b";
export var shopifyIcon = "_pz-c";
export var suggestionBadge = "_pz-e";
export var suggestionText = "_pz-f";
export var username = "_pz-9";